import { convertViolationsFormValuesToKnmData } from 'KnmErknmPackage/MainModule/common/convertViolationsFormValuesToKnmData';

import { IKnmErknmFormViolatedRequirementsNpa } from '../interfaces/IKnmErknmFormViolatedRequirementsNpa';
import {
  IKnmViolatedRequirementsMandatory248,
  IKnmViolatedRequirementsNpa248,
} from '../../../APIPackage/KnmModule/interfaces/IKnmViolatedRequirementsNpa248';
import { formatDate } from '../../../CorePackage/MainModule/common/formatDate';
import { DATE_FORMAT_LONG_FNS, SYSTEM_DATE_FORMAT_FNS } from '../../../CorePackage/MainModule/constants/dateFormats';

export function convertViolatedRequirementsFormValuesToKnmData(
  violatedRequirements: IKnmErknmFormViolatedRequirementsNpa[] | undefined,
  isDraft?: boolean,
): IKnmViolatedRequirementsNpa248[] | null {
  if (!violatedRequirements) return null;

  return violatedRequirements.map(item => {
    const { npa, structuralUnit, violatedMandatory, guid } = item;

    const violatedRequirement: IKnmViolatedRequirementsNpa248 = {
      guid,
      npaId: npa.id,
      number: npa.number || null,
      title: npa.title || null,
      acceptanceDate: formatDate({
        date: npa.acceptanceDate ?? '',
        dateFormat: SYSTEM_DATE_FORMAT_FNS,
        parseFormat: DATE_FORMAT_LONG_FNS,
      }),
      structuralUnit: {
        id: structuralUnit.id,
        title: structuralUnit.title || null,
        mandatoryRequirementsViolations: violatedMandatory.map(mandatoryItem => {
          const safeViolationIds = mandatoryItem.violations
            ? mandatoryItem.violations.map(vs => vs.id).filter((id): id is string => id != null)
            : undefined;

          const mandatoryRequirementsViolation: IKnmViolatedRequirementsMandatory248 = {
            id: mandatoryItem.mandatory.id,
            title: mandatoryItem.mandatory.title,
            category: mandatoryItem.category
              ? {
                  id: mandatoryItem.category.id,
                  name: mandatoryItem.category.name,
                }
              : null,
            violationIds: safeViolationIds,
            violations: mandatoryItem.violations?.length
              ? convertViolationsFormValuesToKnmData(mandatoryItem.violations, isDraft)
              : null,
          };

          return mandatoryRequirementsViolation;
        }),
      },
    };

    return violatedRequirement;
  });
}
